import PopupLayout from '@components/Common/PopupLayout';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MintlyTable from '@components/Common/Table';
import { Container, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import './index.scss';

interface RelevancyViewData {
  relevantCandidates: {
    jobSeekerId: string;
    jobSeekerName: string;
    percentage: number;
  }[];
  onClose: () => void;
}

const RelevancyViewPopup = ({ relevantCandidates, onClose }: RelevancyViewData) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;

  // Sort the candidates by match percentage in descending order
  const sortedCandidates = [...relevantCandidates].sort((a, b) => b.percentage - a.percentage);

  const handleViewProfile = (jobSeekerId: string) => {
    setTimeout(() => {
      window.open(`/jobseekers/${jobSeekerId}`, '_blank', 'noopener,noreferrer');
    }, 100);
  };

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  return (
    <PopupLayout className="relevancy-view-popup-layout-container">
      <Container className="relevancy-view-container" maxWidth="sm">
        <div className='overview-card'>
          <Typography align="left" className="card-header gradient-text" variant="subtitle1">
            Relevant Candidates (AI Generated)
          </Typography>
          <AutoAwesomeIcon className="icon-accent" />
          <IconButton
            aria-label="close"
            className="margin-left-auto"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <MintlyTable
          rows={sortedCandidates.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
          selectors={['jobSeekerName', 'percentage', 'actions']}
          tableHeadRow={{
            jobSeekerName: 'Name',
            percentage: 'Match Percentage',
            actions: 'Actions',
          }}
          tableBodyRow={{
            jobSeekerName: (c: any) => c.jobSeekerName,
            percentage: (c: any) => `${Math.round(c.percentage)}%`,
            actions: (c: any) => (
              <IconButton size="small" color="primary" onClick={() => handleViewProfile(c.jobSeekerId)}>
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            ),
          }}
          pagination={{
            enabled: true,
            page,
            rowsPerPage,
            totalNumberOfRows: sortedCandidates.length,
            handleChangePage,
          }}
        />
      </Container>
    </PopupLayout>
  );
};

export default RelevancyViewPopup;
